import { render } from "./ThePicturesFilterNew.vue?vue&type=template&id=e3dc7060"
import script from "./ThePicturesFilterNew.vue?vue&type=script&lang=js"
export * from "./ThePicturesFilterNew.vue?vue&type=script&lang=js"

import "./ThePicturesFilterNew.vue?vue&type=style&index=0&id=e3dc7060&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__